import styled from 'styled-components';

export const ProductListWrapper = styled.div`
    padding: 0 10px 0 10px;
`;

export const Btn = styled.button`
    background-color: Transparent;
    background-repeat:no-repeat;
    border: none;
    cursor:pointer;
    overflow: hidden;
    outline:none;
    color: darkgray;
    font-size: large;

    &:hover{
        background-color: red;
    }
`